const Distributors = {
  Covetrus: "covetrus",
  MidwestVeterinarySupply: "midwest_veterinary_supply",
  PattersonVeterinary: "patterson_veterinary",
  MWIAnimalHealth: "mwi_animal_health",
} as const;

export type Distributor = (typeof Distributors)[keyof typeof Distributors];

// Individual constants for easy importing
export const DISTRIBUTOR_COVETRUS = Distributors.Covetrus;
export const DISTRIBUTOR_MIDWEST = Distributors.MidwestVeterinarySupply;
export const DISTRIBUTOR_PATTERSON = Distributors.PattersonVeterinary;
export const DISTRIBUTOR_MWI = Distributors.MWIAnimalHealth;

// Distributor display names
export const DISTRIBUTOR_NAMES = {
  [DISTRIBUTOR_COVETRUS]: "Covetrus",
  [DISTRIBUTOR_PATTERSON]: "Patterson Veterinary",
  [DISTRIBUTOR_MWI]: "MWI Animal Health",
  [DISTRIBUTOR_MIDWEST]: "Midwest Veterinary Supply",
} as const;

export const distributorNameToSlug = (name: string): string => {
  // Normalize the input: trim whitespace and normalize multiple spaces to single space
  const normalizedName = name.trim().replace(/\s+/g, " ");

  // Try exact match first (case-sensitive)
  let entry = Object.entries(DISTRIBUTOR_NAMES).find(
    ([_, displayName]) => displayName === normalizedName,
  );

  // If no exact match, try case-insensitive match
  if (!entry) {
    entry = Object.entries(DISTRIBUTOR_NAMES).find(
      ([_, displayName]) =>
        displayName.toLowerCase() === normalizedName.toLowerCase(),
    );
  }

  // If still no match, try partial matches for common variations
  if (!entry) {
    const lowerName = normalizedName.toLowerCase();
    // Handle common variations
    if (lowerName === "midwest" || lowerName.startsWith("midwest")) {
      entry = Object.entries(DISTRIBUTOR_NAMES).find(
        ([slug]) => slug === DISTRIBUTOR_MIDWEST,
      );
    } else if (lowerName === "patterson" || lowerName.startsWith("patterson")) {
      entry = Object.entries(DISTRIBUTOR_NAMES).find(
        ([slug]) => slug === DISTRIBUTOR_PATTERSON,
      );
    } else if (lowerName === "mwi" || lowerName.startsWith("mwi")) {
      entry = Object.entries(DISTRIBUTOR_NAMES).find(
        ([slug]) => slug === DISTRIBUTOR_MWI,
      );
    }
  }

  // Return the slug if found, otherwise fallback to normalized slug conversion
  return entry ? entry[0] : normalizedName.toLowerCase().replace(/\s+/g, "_");
};

export const distributorSlugToName = (slug: string): string => {
  return DISTRIBUTOR_NAMES[slug as Distributor] || slug;
};

export default Distributors;
